import axios from '~/api/axios';

export const bankValidation = (body: any) => {
  return axios.post<void>('/stages/ksa/application/iban/verify', body).then((res) => res.data);
};
